import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axiosInstance from "../../../services/AxiosInstance";
import Api from "../../../constants/Api";
import { successAlert } from "../alert/defaultAlert";
import YesNoSelect from "../Common/YesNoSelect";
import { convertBooleanToYesOrNo, convertYesOrNoToBoolean } from "../../../utils/ConverterUtils";
import HintTooltip from "../Common/HintTooltip";

const MainSetting = () => {

    const { t } = useTranslation();
    const [requireBranchInCustomer, setRequireBranchInCustomer] = useState(null);
    const [requireCpfInCustomer, setRequireCpfInCustomer] = useState(null);
    const save = () => {
        let data = {
            requireBranchInCustomer: convertYesOrNoToBoolean(requireBranchInCustomer?.value || "N"),
            requireCpfInCustomer: convertYesOrNoToBoolean(requireCpfInCustomer?.value || "N")
        }

        axiosInstance.post(Api.parameter.main, data).then(() => successAlert(t('message.data_updated_successfully'), null));
    }

    useEffect(() => {
        axiosInstance.get(Api.parameter.main)
            .then((resp) => {
                if (resp.data.length > 0) {
                    let data = resp.data[0];
                    setRequireBranchInCustomer({
                        value: convertBooleanToYesOrNo(data.requireBranchInCustomer),
                        label: convertBooleanToYesOrNo(data.requireBranchInCustomer) === "Y" ? t('yes') : t('no')
                    });

                    setRequireCpfInCustomer({
                        value: convertBooleanToYesOrNo(data.requireCpfInCustomer),
                        label: convertBooleanToYesOrNo(data.requireCpfInCustomer) === "Y" ? t('yes') : t('no')
                    });

                }
            });
    }, []);

    return (
        <div className="card">
            <div className="card-body">
                <h3 className="mb-2">{t('main')}</h3>
                <p className="text-muted small mb-4">O módulo de cadastros oferece configurações personalizáveis para otimizar e organizar os registros, alinhando-se aos objetivos e às necessidades específicas do seu negócio.</p>
                <hr className="my-4" />
                <div className="row">
                    <div className="col-md-6">
                        <div className="setting-input">
                            <label className="form-label">{t('require_branch_in_customer_question')} <HintTooltip text={t('message.require_branch_in_customer_hint')} /></label>
                            <YesNoSelect
                                name="requireBranchInCustomer"
                                onChange={(value) => setRequireBranchInCustomer(value)}
                                value={requireBranchInCustomer} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="setting-input">
                            <label className="form-label">{t('require_cpf_in_customer_question')} <HintTooltip text={t('message.require_cpf_in_customer_hint')} /></label>
                            <YesNoSelect
                                name="requireCpfInCustomer"
                                onChange={(value) => setRequireCpfInCustomer(value)}
                                value={requireCpfInCustomer} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <Link to={"#"} className="btn btn-primary btn-md" onClick={() => save()}>{t('save_setting')}</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainSetting;
